<script>

import FormFieldDisplay from "./../FormFieldDisplay";

export default {
  props: ['item', 'mls_page', 'lang', 'admin'],
  components: { FormFieldDisplay },
  data() {
    return {
      loading: false,
      mls_field_values: {},
      prop_type: "",
    }
  },
  computed: {

  },
  created() {
    if(this.item.PropertyType && this.item.PropertyType == "Business Opportunity") { this.prop_type = "BUSO"; }
    if(this.item.PropertyType && this.item.PropertyType == "Commercial Lease") { this.prop_type = "COML"; }
    if(this.item.PropertyType && this.item.PropertyType == "Commercial Sale") { this.prop_type = "COMS"; }
    if(this.item.PropertyType && this.item.PropertyType == "Farm") { this.prop_type = "FARM"; }
    if(this.item.PropertyType && this.item.PropertyType == "Land") { this.prop_type = "LAND"; }
    if(this.item.PropertyType && this.item.PropertyType == "Manufactured In Park") { this.prop_type = "MOBI"; }
    if(this.item.PropertyType && this.item.PropertyType == "Residential") { this.prop_type = "RESI"; }
    if(this.item.PropertyType && this.item.PropertyType == "Residential Income") { this.prop_type = "RINC"; }
    if(this.item.PropertyType && this.item.PropertyType == "Residential Lease") { this.prop_type = "RLSE"; }
    
    var output = {};
    for(var i in this.item) {
      if(typeof this.item[i] != 'array' && typeof this.item[i] != 'object') {
        output[i] = {
          used: 0,
          output: (this.item[i] === null ? '' : this.item[i]),
        };
      }
    }
    if(this.item.additional_input && typeof this.item.additional_input != 'array') { for(var i in this.item.additional_input) {
      if(typeof this.item.additional_input[i] != 'array' && typeof this.item.additional_input[i] != 'object' && output[i] === undefined) {
        output[i] = {
          used: 0,
          output: (this.item.additional_input[i] === null ? '' : this.item.additional_input[i]),
        };
      }
    } }
    if(this.item.mls && this.item.mls.form_fields) { for(var page in this.item.mls.form_fields) { for(var content in this.item.mls.form_fields[page].content) {
      if(this.item.mls.form_fields[page].content[content].FieldType == 'reso' || this.item.mls.form_fields[page].content[content].FieldType == 'custom') {

        if(output[this.item.mls.form_fields[page].content[content].StandardName]) {
          output[this.item.mls.form_fields[page].content[content].StandardName].used = output[this.item.mls.form_fields[page].content[content].StandardName].used + 1;
        } else {
          output[this.item.mls.form_fields[page].content[content].StandardName] = {
            used: 1,
            output: (this.item.mls.form_fields[page].content[content].Default === null ? '' : this.item.mls.form_fields[page].content[content].Default),
          };
        }
      }
    } } }
    this.mls_field_values = output;
  },
  methods: {
    submit_form(justsave = false) {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;

      for(var i in this.mls_field_values) {
        if(this.mls_field_values[i].used > 0) {
          if(this.item[i] === undefined) {
            if(this.mls_field_values[i].output instanceof Array) {
              this.item.additional_input[i] = this.mls_field_values[i].output.join(", ");
            } else {
              this.item.additional_input[i] = this.mls_field_values[i].output;
            }
          } else {
            if(this.mls_field_values[i].output instanceof Array) {
              this.item[i] = this.mls_field_values[i].output.join(", ");
            } else {
              this.item[i] = this.mls_field_values[i].output;
            }
          }
        }
      }
      
      if(!justsave && !this.admin && this.mls_page == this.item.mls.form_fields.length - 1) {
        let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
        var n = new Noty({
          timeout: false,
          modal: true,
          type: 'alert', // alert, success, warning, error, info
          layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
          closeWith: ['button'], // click, button
          text: "Are you sure you have completed the property details section? Once the form is submitted, you will have to request access to make changes.",
          buttons: [
            Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> Yes, Submit', 'btn btn-success px-4 float-right ml-2', notyres => {
              var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
              if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
              this.item.overwrite = true;
              this.$http.put((this.admin ? 'api' : '')+'/listings/update-forms', this.item).then(res => {
                // console.log(res);
                if(res.data && res.data.StandardStatus) { this.item.StandardStatus = res.data.StandardStatus; }
                if(res.data && res.data.updated_at) { this.item.updated_at = res.data.updated_at; }
                this.loading = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
                this.$emit('curpage');
                n.close();
              }).catch(res => { this.popupErrors(res); this.loading = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
            }, {id: randomid, 'data-status': 'ok'}),
            Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
              n.close();
            }, {id: randomid+'_no', 'data-status': 'ok'}),
          ]
        }).show().on('onClose', () => { this.loading = false; });
      } else {
        this.$http.put((this.admin ? 'api' : '')+'/listings/update-forms-auto', this.item).then(res => {
          // console.log(res);
          if(res.data && res.data.updated_at) { this.item.updated_at = res.data.updated_at; }
          if(!justsave) { this.$emit('setpage', 7 + (this.mls_page + 1) + 1); }
          if(this.admin) { $("html, body").animate({ scrollTop: 0 }, "slow"); }
          this.$noty.success('Save complete');
          this.loading = false;
        }).catch(res => {
          // console.log(res.response);
          if(this.gs(()=>res.response.data.newer)) {
            let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
            var n = new Noty({
              timeout: false,
              modal: true,
              type: 'alert', // alert, success, warning, error, info
              layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
              closeWith: ['button'], // click, button
              text: "A newer version of this listing data already exists. Overwrite the listing data with your changes?",
              buttons: [
                Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> Save Changes', 'btn btn-success px-4 float-right ml-2', notyres => {
                  var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
                  if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
                  this.item.overwrite = true;
                  this.$http.put((this.admin ? 'api' : '')+'/listings/update-forms-auto', this.item).then(res => {
                    // console.log(res);
                    if(res.data && res.data.updated_at) { this.item.updated_at = res.data.updated_at; }
                    this.$noty.success('Save complete');
                    this.loading = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
                    if(!justsave) { this.$emit('setpage', 7 + (this.mls_page + 1) + 1); }
                    if(this.admin) { $("html, body").animate({ scrollTop: 0 }, "slow"); }
                    n.close();
                  }).catch(res => { this.popupErrors(res); this.loading = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
                }, {id: randomid, 'data-status': 'ok'}),
                Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
                  n.close();
                }, {id: randomid+'_no', 'data-status': 'ok'}),
              ]
            }).show().on('onClose', () => { this.loading = false; });
          } else { this.loading = false; }
        });
      }

    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto" :class="!admin ? 'my-5' : ''">
    <form @submit.prevent="submit_form()">

      <!-- <option value="Business Opportunity">Business Opportunity</option> BUSO
      <option value="Commercial Lease">Commercial Lease</option> COML
      <option value="Commercial Sale">Commercial Sale</option> COMS
      <option value="Farm">Farm</option> FARM
      <option value="Land">Land</option> LAND
      <option value="Manufactured In Park">Manufactured In Park</option> MOBI
      <option value="Residential">Residential</option> RESI
      <option value="Residential Income">Residential Income</option> RINC
      <option value="Residential Lease">Residential Lease</option> RLSE -->

      <div class="row">
        <FormFieldDisplay
        v-for="(content, content_i) in item.mls.form_fields[mls_page].content"
        v-if="content.PropertyTypes.includes(prop_type)"
        :key="'c'+content_i"
        :content="content"
        :mls_field_values="mls_field_values"
        :lang="lang"
        ></FormFieldDisplay>
      </div>
      <div class="row py-5">
        <div class="col-6">
          <button v-if="!admin || (mls_page + 1) != 1" type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 7 + (mls_page + 1) - 1)" :disabled="loading"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">
          <button type="button" class="btn btn-lg btn-light border mr-sm-3" @click="submit_form(true)" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Save <Icon icon="ri:save-line" /></button>
          <button v-if="!admin" type="submit" class="btn btn-lg btn-success" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> {{ mls_page == item.mls.form_fields.length - 1 ? 'Submit' : 'Save and continue' }} <Icon icon="ri:arrow-right-double-fill" /></button>
          <button v-if="admin && mls_page != item.mls.form_fields.length - 1" type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 7 + (mls_page + 1) + 1)" :disabled="loading"> Next <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
    <!-- <pre>{{ item['Heating'] }}</pre>
    <pre>{{ mls_field_values['Heating'] }}</pre> -->
  </div>

</template>
